module.exports = __webpack_public_path__ + "img/QF.72631952.jpg";